import { render } from "./ConvocatoriasMatriculaList.vue?vue&type=template&id=59498d6a"
import script from "./ConvocatoriasMatriculaList.vue?vue&type=script&lang=js"
export * from "./ConvocatoriasMatriculaList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__